import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combina classes Tailwind resolvendo conflitos — a última vence.
 *
 * F4.1.1.a. `clsx` e `tailwind-merge` já estavam no package.json desde o início
 * do projeto e nunca foram importados: as classes eram concatenadas por template
 * string em `components/ui/Button.tsx`, o que fazia `className` do consumidor
 * perder para a variante em vez de sobrescrevê-la.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
